import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import Shopkeeper from "../../Services/shopkeeperServices";
import { QRCodeCanvas } from "qrcode.react";
import { frontBaseUrl } from "../../config/EnVariables";
import { AuthContext } from "../../Auth/Context/AuthContext";
function ShopKeeperDetails(props) {
  const { user } = useContext(AuthContext);
  const shopKeeperId = useParams().id;
  const [shopKeeper, setShopKeeper] = useState({});
  const [shopkeeperShops, setShopkeeperShops] = useState();
  const [loading, setLoading] = useState(false);
  const [rents, setRents] = useState();
  const getShopKeeper = async () => {
    setLoading(true);
    await Shopkeeper.getOne(shopKeeperId)
      .then((data) => {
        setShopKeeper(data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const getShopkeeperRents = async () => {
    setLoading(true);
    await Shopkeeper.getRents(shopKeeperId)
      .then((data) => {
        console.log("____ shopkeeper rents", data.data);
        setRents(data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const getShopkeeperShops = async () => {
    setLoading(true);
    await Shopkeeper.getShops(shopKeeperId)
      .then((data) => {
        console.log("____ shopkeeper shops", data.data);
        setShopkeeperShops(data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getShopKeeper();
    getShopkeeperRents();
    getShopkeeperShops();
  }, []);

  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div class="page-wrapper">
        <div class="content">
          <div class="page-header">
            <div class="page-title">
              <h4>ShopKeeper Details</h4>
              <h6>Full details of a shopkeeper</h6>
            </div>
          </div>
          <QRCodeCanvas
            value={`${frontBaseUrl}/shopkeeper/${shopKeeperId}/full-details`}
          />
          <a href={`${frontBaseUrl}/shopkeeper/${shopKeeperId}/full-details`}>
            QR Details
          </a>
          <div class="row">
            <div class="col-lg-8 col-sm-12">
              <div class="card">
                <div class="card-body">
                  <div class="productdetails">
                    <ul class="product-bar">
                      <li>
                        <h4>Name</h4>
                        <h6>{shopKeeper.name} </h6>
                      </li>
                      <li>
                        <h4>Address</h4>
                        <h6>{shopKeeper.address}</h6>
                      </li>
                      <li>
                        <h4>Phone</h4>
                        <h6>{shopKeeper.phone}</h6>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <h2>Rents History</h2>
          <table className="table">
            <thead>
              <th>Transaction</th>
              <th>Date</th>
              <th>Shop</th>
              <th>Amount</th>
              <th>Type</th>
              <th>Exc Rate</th>
            </thead>
            <tbody>
              {rents?.map((item) => (
                <tr>
                  <td>{item.name}</td>
                  <td>{item.date}</td>
                  <td>{item.shopName}</td>
                  <td>{item.amount || "$0.00"}</td>
                  <td>{item.transactionType}</td>
                  <td>{item.currencyRate}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <h2>Shops History</h2>
          <table className="table">
            <thead>
              <th>Transaction</th>
              <th>Date</th>
              <th>Shop</th>
              <th>Contract</th>
              <th>Status</th>
            </thead>
            <tbody>
              {shopkeeperShops?.map((item) => (
                <tr>
                  <td>{item.name}</td>
                  <td>{item.contractDate}</td>
                  <td>{item.shopName}</td>
                  <td>{item.contractType}</td>
                  <td>{item.state}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default ShopKeeperDetails;
